import {
  CHARACTER_WHITESPACE,
  EMPTY_LIST,
} from '../../../../../constants/common'
import { getRentalPortalApplicantIdentityLabel } from '../../../../RentalPortalApplicant'

import {
  APPLICANT_DECISION_ACTION,
  APPLICANT_DECISION_CONFLICT_KEY,
} from './ApplicantDecisionPanel.constants'
import {
  getApplicantDecisionTransition,
  getIsApplicantDecisionSelfApproval,
  getIsApplicantScreeningStage,
  getIsApplicantSelectedStage,
} from './ApplicantDecisionPanel.utils'

function toApprovedApplicantIdentity(approvedApplicant) {
  const name = [approvedApplicant.first_name, approvedApplicant.last_name]
    .filter(Boolean)
    .join(CHARACTER_WHITESPACE)

  return {
    identity: { masked: !name, value: name },
    reference: approvedApplicant.reference,
  }
}

function getApplicantDecisionRefusalTooltip({ t, transition }) {
  return transition.approved_applicant
    ? t('RentalPortal.ApplicantDecisionListingApprovedNamedTooltipKey', {
        applicant: getRentalPortalApplicantIdentityLabel({
          applicant: toApprovedApplicantIdentity(transition.approved_applicant),
          t,
        }),
      })
    : t(
        APPLICANT_DECISION_CONFLICT_KEY[transition.reason] ??
          'RentalPortal.ApplicantProfileStageTransitionNotAllowedTooltipKey'
      )
}

function toApplicantDecisionAction({ action, applicantData, t }) {
  const transition = getApplicantDecisionTransition({ action, applicantData })

  return transition
    ? {
        key: action,
        tooltip: transition.permitted
          ? null
          : getApplicantDecisionRefusalTooltip({ t, transition }),
      }
    : null
}

export function getApplicantDecisionSelectActions({ applicantData, t }) {
  const selectAction = toApplicantDecisionAction({
    action: APPLICANT_DECISION_ACTION.select,
    applicantData,
    t,
  })

  return getIsApplicantScreeningStage(applicantData) &&
    applicantData.permissions?.can_select &&
    selectAction
    ? [selectAction]
    : EMPTY_LIST
}

export function getApplicantDecisionApprovalActions({
  applicantData,
  currentUserId,
  t,
}) {
  if (
    !getIsApplicantSelectedStage(applicantData) ||
    !applicantData.permissions?.can_approve
  ) {
    return EMPTY_LIST
  }

  const selfApprovalTooltip = getIsApplicantDecisionSelfApproval({
    applicantData,
    currentUserId,
  })
    ? t('RentalPortal.ApplicantDecisionSelectorBlockedTooltipKey')
    : null

  return [
    APPLICANT_DECISION_ACTION.approve,
    APPLICANT_DECISION_ACTION.rejectSelection,
  ]
    .map(action => toApplicantDecisionAction({ action, applicantData, t }))
    .filter(Boolean)
    .map(action => ({
      ...action,
      tooltip: selfApprovalTooltip ?? action.tooltip,
    }))
}
